import { api } from './api';
import { unwrapList } from './unwrapList';
import { SubscriptionPlan, SubscriptionPlanCreateData, SubscriptionPlanUpdateData } from '../types/subscriptionPlan';

interface UpdateResponse {
    message: string;
    data: SubscriptionPlan;
    stripeChanges?: string[];
}

export const subscriptionPlanAdminService = {
    getAll: async (): Promise<SubscriptionPlan[]> => {
        const response = await api.get<{ data: SubscriptionPlan[] }>('/admin/subscription-plans');
        return unwrapList<SubscriptionPlan>(response.data);
    },

    create: async (data: SubscriptionPlanCreateData): Promise<SubscriptionPlan> => {
        const response = await api.post<{ data: SubscriptionPlan }>('/admin/subscription-plans', data);
        return response.data.data;
    },

    update: async (id: number, data: SubscriptionPlanUpdateData): Promise<UpdateResponse> => {
        const response = await api.put<UpdateResponse>(`/admin/subscription-plans/${id}`, data);
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await api.delete(`/admin/subscription-plans/${id}`);
    },

    sync: async (id: number): Promise<SubscriptionPlan> => {
        const response = await api.post<{ data: SubscriptionPlan }>(`/admin/subscription-plans/${id}/sync`);
        return response.data.data;
    },
};
